import { Avatar, Stack, Typography } from '@mui/material';
import { LinkReturnToMain } from 'Components/LinkReturnToMain';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';
import { ContentHeaderBG } from 'Images';
import { FC, ReactNode } from 'react';

interface IContentHeader {
  isSuccessPage?: boolean;
  children: ReactNode;
  isOtp?: boolean;
  isAuth?: boolean;
  selectedCategoryId?: number | null;
  selectedSubCategoryId?: number | null;
  clearCategory?: () => void;
  clearSubCategory?: () => void;
}

export const ContentHeader: FC<IContentHeader> = ({
  isSuccessPage,
  children,
  isOtp,
  isAuth,
  selectedCategoryId,
  selectedSubCategoryId,
  clearCategory,
  clearSubCategory,
}: IContentHeader) => {
  const isDesktop = useIsDesktop();
  const dictionary = Dictionary[DICTIONARY.ContentHeader];

  const isSubcategories =
    selectedCategoryId !== null && selectedSubCategoryId === null;
  const isUploadFiles = selectedSubCategoryId !== null && !isSuccessPage;

  const getLinkLabel = () =>
    isSubcategories || isUploadFiles ? dictionary.back : undefined;

  const getLinkClick = () => {
    if (isSubcategories && clearCategory) {
      return clearCategory();
    }
    if (isUploadFiles && clearSubCategory) {
      return clearSubCategory();
    }
    window.location.assign(`${process.env.REACT_APP_REDIRECT_URL}`);
  };

  return (
    <Stack
      position={'relative'}
      boxShadow={'0px 4px 20px rgba(21, 82, 232, 0.12)'}
      padding={isDesktop ? '32px 250px 0 250px' : '32px 10px'}
    >
      <Avatar
        src={ContentHeaderBG}
        alt={''}
        sx={{
          width: '100%',
          height: '100%',
          position: 'absolute',
          top: '0',
          left: 0,
        }}
      />
      <Stack gap={'10px'} zIndex={1}>
        {!isOtp && isAuth && (
          <LinkReturnToMain label={getLinkLabel()} onClick={getLinkClick} />
        )}
        <Stack alignItems={'center'} gap={'12px'}>
          <Typography variant={'h2'}>
            {isSuccessPage ? dictionary.successPage : dictionary.title}
          </Typography>
          {children}
        </Stack>
      </Stack>
    </Stack>
  );
};
